import React from 'react';
import { Typography } from 'antd';
import ThreeDRotationIcon from '@mui/icons-material/ThreeDRotation';
import { primaryShades } from '../../theme/theme';

const { Text } = Typography;

const COLORS = {
    modelIcon: primaryShades.primary300,
    backgroundSemiTransparent: 'rgba(255,255,255,0.7)',
};

const SIZES = {
    spacingM: '1rem',
    fontXlarge: '4rem',
    radiusSmall: '0.25rem',
};

const Model3DLoader = ({ modelUrl, onLoad, onError }) => {

    const handleIframeLoad = () => {
        setTimeout(() => {
            if (onLoad) onLoad();
        }, 500);
    };

    const handleIframeError = () => {
        if (onError) onError();
    };

    if (!modelUrl) {
        return (
            <div style={{
                width: '100%',
                height: '100%',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                flexDirection: 'column'
            }}>
                <ThreeDRotationIcon style={{
                    fontSize: SIZES.fontXlarge,
                    color: COLORS.modelIcon,
                    marginBottom: SIZES.spacingM
                }} />
                <Text>3D Model not available</Text>
            </div>
        );
    }

    return (
        <div style={{ width: '100%', height: '100%', position: 'relative' }}>
            <iframe
                src={modelUrl}
                title="3D Model"
                style={{
                    width: '100%',
                    height: '100%',
                    border: 'none',
                    borderRadius: SIZES.radiusSmall,
                    overflow: 'hidden'
                }}
                allowFullScreen
                onLoad={handleIframeLoad}
                onError={handleIframeError}
            />
        </div>
    );
};

export default Model3DLoader; 